<template>
  <div style="position relative;">
    <div class="header">
      <v-btn icon small text class="handle" :class="'handle-depth-' + depth">
        <v-icon small>mdi-drag</v-icon>
      </v-btn>
      <div style="flex-grow: 1"></div>
      <slot name="right" />
      <v-btn text @click="$emit('remove-click')" color="red" small icon
        ><v-icon small>mdi-close</v-icon></v-btn
      >
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ["depth"],
};
</script>

<style scoped>
.header {
  height: 30px;
  display: flex;
}
.handle {
  cursor: ns-resize;
  margin-top: 2px;
  position: absolute;
  top: 0;
  left: 0;
}

.dots-button {
  margin-top: 2px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>